import React, { createContext, useState } from 'react';

interface HandleToastAlertProps {
  message: string;
  severity: 'success' | 'info' | 'warning' | 'error';
  open: boolean;
}

interface ToastAlertContextData {
  openToast: boolean;
  setOpenToast: React.Dispatch<React.SetStateAction<boolean>>;
  alertMessage: string;
  setAlertMessage: React.Dispatch<React.SetStateAction<string>>;
  alertSeverity: 'success' | 'info' | 'warning' | 'error';
  setAlertSeverity: React.Dispatch<React.SetStateAction<'success' | 'info' | 'warning' | 'error'>>;
  handleClose: () => void;
  handleToastAlert: (props: HandleToastAlertProps) => void;
}

interface IToastAlertProvider {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
}

export const ToastAlertContext = createContext<ToastAlertContextData>({} as ToastAlertContextData);

const ToastProvider: React.FC<IToastAlertProvider> = ({ children }) => {
  const [openToast, setOpenToast] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>('');
  const [alertSeverity, setAlertSeverity] = useState<'success' | 'info' | 'warning' | 'error'>('error');

  const handleClose = () => setOpenToast(false);

  const handleToastAlert = ({ open, message, severity }: HandleToastAlertProps) => {
    setOpenToast(open);
    setAlertMessage(message);
    setAlertSeverity(severity);
  };

  return (
    <ToastAlertContext.Provider
      value={{
        openToast,
        setOpenToast,
        handleClose,
        handleToastAlert,
        alertMessage,
        setAlertMessage,
        alertSeverity,
        setAlertSeverity
      }}
    >
      {children}
    </ToastAlertContext.Provider>
  );
};

export default ToastProvider;
